interface TreeNode {
	value: string;
	title: string | JSX.Element;
	selectable?: boolean;
	disabled?: boolean;
	children?: TreeNode[];
}

export const objectToAntdTree = (
	obj: Record<string, any>,
	parentKey = '',
	arraySelectable = false,
	parentPath = '',
	restrictionType = ''
): TreeNode[] => {
	return Object.keys(obj).map((key, index) => {
		const newKey = parentKey ? `${parentKey}-${index}` : `${index}`;
		const newPath = parentPath ? `${parentPath}.${key}` : key; 
		const node: TreeNode = {
			value: newPath,
			title: key,
			selectable: false,
  
		};

		if (typeof obj[key] === 'object' && obj[key] !== null && Object.keys(obj[key]).length > 0 && !Array.isArray(obj[key])) {
			node.children = objectToAntdTree(obj[key], newKey, arraySelectable, newPath, restrictionType); 
		} else {
			const isArray = Array.isArray(obj[key]);
     
			node.selectable = isArray ? arraySelectable : true;
			node.disabled = isArray ? !arraySelectable : false;

			if(!!restrictionType && !(restrictionType == typeof obj[key])) {
				node.disabled = true;
				node.selectable = false;
			}

		}

		return node;
	});
};